(ns frontend.ui.page.lp-portal.landing-page.reports-section.commitments-dashboard.view
  (:require
   [frontend.ui.page.lp-portal.landing-page.reports-section.commitments-dashboard.style :as style]
   [frontend.ui.style.theme.core :as theme]
   [herb.core :refer [<class]]
   [frontend.ui.component.chart.view :as chart]
   [frontend.ui.component.lp-portal.checkbox.view :as checkbox]
   [frontend.ui.page.lp-portal.landing-page.sub :as sub]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [frontend.utils :as fu]))

(def hidden-vehicle-ids (r/atom #{}))

(defn fund-committed-amount
  [commitments]
  [(->> commitments
        (sort-by
         (fn [c]
           (get-in c [:lp-commitment :lp-report-investor-commitment/data :reference-date] 0)))
        (last)
        :fund-name)
   (->> commitments
        (map (fn [ic]
               (or (get-in ic [:lp-commitment :lp-report-investor-commitment/data :nav])
                   (get-in ic [:lp-commitment :lp-report-investor-commitment/data :fair-value] 0))))
        (apply +))])

(defn resolve-chart-data
  [all-commitments]
  (let [hidden-ids @hidden-vehicle-ids
        filtered-commitments (->> all-commitments
                                  (group-by
                                   (fn [commitment]
                                     (get-in commitment
                                             [:lp-commitment :lp-report-investor-commitment/data
                                              :investor-uuid])))
                                  (mapcat (fn [[investor-id investor-commitments]]
                                            (when-not (get hidden-ids investor-id)
                                              investor-commitments))))]
    (->> filtered-commitments
         (group-by :fund-id)
         (map second)
         (map fund-committed-amount)
         (map (fn [[fund-name total-commitment-amount]]
                (let [decimals-shown (if (< total-commitment-amount 1000000) 2 1)
                      formatted-amount (-> total-commitment-amount
                                           (/ 1000000)
                                           (fu/round decimals-shown))]
                  {:name fund-name
                   :y    total-commitment-amount
                   :formatted-amount formatted-amount})))
         (doall))))

(defn commitments-dashboard
  []
  (fn []
    (let [landing-page-data @(rf/subscribe [::sub/landing-page-data])
          all-commitments (concat (:landing-page-lp-commitments landing-page-data)
                                  (:landing-page-feeder-commitments landing-page-data))
          hidden-ids @hidden-vehicle-ids
          user-fund-positions-chart-data (resolve-chart-data all-commitments)]
      [:div
       {:class (<class style/container)}
       [:h2
        {:class (<class style/title)}
        "Fund positions by latest NAV"]
       [:div
        {:class (<class style/content)}
        [chart/chart
         {:container-style {"flex" "1 1 auto"}
          :series          [{:data      user-fund-positions-chart-data
                             :innerSize :63%
                             :animation false}]
          :chart           {:type "pie"}
          :colors          (theme/colors [:lp-portal :dashboard :pie-colors])
          :tooltip         {:pointFormat "{point.formatted-amount} M€"}
          :plotOptions     {:pie {:dataLabels {:format
                                               "{point.name}<br/>{point.formatted-amount} M€"
                                               :style  {:fontSize :16px}}}}}]
        [:div
         {:class (<class style/filter-desktop)}
         [:h2
          {:class (<class style/filter-desktop-title)}
          "Vehicles"]
         [:div
          {:class (<class style/filter-desktop-list)}
          (->> all-commitments
               (map :lp-commitment)
               (map (fn [commitment]
                      [(some->> commitment
                                :lp-report-investor-commitment/data
                                :investor-uuid)
                       (some->> commitment
                                :lp-report-investor-commitment/investor-name)]))
               (distinct)
               (sort-by second)
               (map
                (fn [[vehicle-id vehicle-name]]
                  (let [is-hidden (contains? hidden-ids vehicle-id)]
                    ^{:key vehicle-id}
                    [:div
                     {:class    (<class style/filter-row)
                      :on-click (fn []
                                  (reset! hidden-vehicle-ids (if is-hidden
                                                               (disj @hidden-vehicle-ids vehicle-id)
                                                               (conj @hidden-vehicle-ids
                                                                     vehicle-id))))}
                     [checkbox/checkbox
                      {:value (not is-hidden)}]
                     vehicle-name])))
               (doall))]]]])))
